import React from 'react';
import './NotifPreview.scss';

interface Props {
  title: string;
  message: string;
}
const NotifPreview: React.FC<Props> = (props) => {
  return (
	  <div className="notif-preview" style={{marginBottom: 20}}>
	    <div className="notif-head">
	      <img className="notif-logo" src={require('../../../images/logo.png')} alt="logo" />
	      <div className="notif-title">Pop Out</div>
	    </div>
	    <div className="notif-msg"><b>{props.title}</b></div>
	    <div className="notif-msg">{props.message}</div>
	  </div>
  );
}

export default NotifPreview;
